import React, { useContext } from 'react'
import styled, { keyframes } from 'styled-components'
import { highestZIndex } from 'shared/css/z-indexes'
import UserContext from 'shared/contexts/user'

const slideIn = keyframes`
    0% {
        top: -57px;
    }
    100% {
        top: 0px;
    }
`
const InnerContainer = styled.div`
    text-align: left;
    width: 1040px;
    min-width: 1040px;
    color: white;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0.21px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Banner = styled.div`
    width: 100%;
    position: absolute;
    top: -57px;
    left: 0;
    height: 57px;
    background: linear-gradient(45deg, rgb(97, 87, 255) 0%, rgb(0, 204, 255) 100%);
    z-index: ${highestZIndex};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: 0.3s ${slideIn} ease-out;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
`

const LeftContent = styled.div`
    display: flex;
    align-items: center;
`

const slideInForCTA = `(max-width: 1100px)`
const RightContent = styled.div`
    @media ${slideInForCTA} {
        transform: translateX(-70px);
        transition: transform 300ms ease-out;
    }
`

const RightArrow = styled.div`
    display: inline;
    position: relative;
    top: 3px;
`

const AnonymousUploadMessage = () => {
    const { isLoggedIn } = useContext(UserContext)
    if (!isLoggedIn) {
        return (
            <Banner>
                <InnerContainer>
                    <LeftContent>
                        Hey! To help ensure safe content, you need to be logged in to upload to GIPHY.
                    </LeftContent>
                    <RightContent>
                        <a href={`/login?next=${location.pathname}`}>
                            Log In or Create an Account <RightArrow className="ss-icon ss-navigateright" />
                        </a>
                    </RightContent>
                </InnerContainer>
            </Banner>
        )
    } else {
        return null
    }
}

export default AnonymousUploadMessage
